import React from 'react';

const pageContainer: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 24,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const sectionHeader: React.CSSProperties = {
  color: '#AAB5E0',
  fontSize: 22,
  textAlign: 'center',
  marginTop: 24,
  marginBottom: 16,
};

const subheader: React.CSSProperties = {
  color: '#AAB5E0',
  fontSize: 18,
  marginTop: 16,
  marginBottom: 8,
};

const text: React.CSSProperties = {
  color: '#FFF',
  fontSize: 14,
  marginTop: 8,
  opacity: 0.95,
  lineHeight: 1.6,
};

const list: React.CSSProperties = {
  color: '#FFF',
  fontSize: 14,
  opacity: 0.95,
  lineHeight: 1.6,
  paddingLeft: 20,
  marginTop: 8,
};

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div style={pageContainer}>
      <div style={shellCard}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16 }}>Privacy Policy</h1>
        
        <div style={text}>Last updated: April 01, 2022</div>
        
        <div style={text}>
          This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
          information when You use the Service and tells You about Your privacy rights and how the law protects You.
        </div>
        
        <div style={text}>
          We use Your Personal data to provide and improve the Service. By using the Service, You agree to the
          collection and use of information in accordance with this Privacy Policy.
        </div>

        <div style={sectionHeader}>Interpretation</div>
        <div style={text}>
          The words of which the initial letter is capitalized have meanings defined under the following conditions.
          The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </div>

        <div style={sectionHeader}>Definitions</div>
        <div style={text}>For the purposes of this Privacy Policy:</div>
        <ul style={list}>
          <li style={{marginTop: 8}}>
            <strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with
            a party, where "control" means ownership of 50% or more of the shares, equity interest or other
            securities entitled to vote for election of directors or other managing authority.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Application</strong> means the software program provided by the Company downloaded by You on any
            electronic device, named Bins Storage.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Company</strong> (referred to as either "the Company", "We", "Us" or
            "Our" in this Agreement) refers to Bins Storage, Inc., 3030 Blazing Star Drive, Thousand Oaks CA 91362.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Country</strong> refers to: California, United States.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Service</strong> refers to the Application.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the
            Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service,
            to provide the Service on behalf of the Company, to perform services related to the Service or to assist the
            Company in analyzing how the Service is used.
          </li>
          <li style={{marginTop: 8}}>
            <strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service
            or from the Service infrastructure itself (for example, the duration of a page visit).
          </li>
          <li style={{marginTop: 8}}>
            <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal
            entity on behalf of which such individual is accessing or using the Service, as applicable.
          </li>
        </ul>

        <div style={sectionHeader}>Types of Data Collected</div>
        <div style={subheader}>Personal Data</div>
        <div style={text}>
          While using Our Service, We may ask You to provide Us with certain personally identifiable information that can
          be used to contact or identify You. Personally identifiable information may include, but is not limited to:
        </div>
        <ul style={list}>
          <li style={{marginTop: 8}}>Email address</li>
          <li style={{marginTop: 8}}>First name and last name</li>
          <li style={{marginTop: 8}}>Phone number</li>
          <li style={{marginTop: 8}}>Address, State, Province, ZIP/Postal code, City</li>
          <li style={{marginTop: 8}}>Usage Data</li>
        </ul>

        <div style={subheader}>Usage Data</div>
        <div style={text}>Usage Data is collected automatically when using the Service.</div>
        
        <div style={text}>
          Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address),
          browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the
          time spent on those pages, unique device identifiers and other diagnostic data.
        </div>
        
        <div style={text}>
          When You access the Service by or through a mobile device, We may collect certain information automatically,
          including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address
          of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device
          identifiers and other diagnostic data.
        </div>
        
        <div style={text}>
          We may also collect information that Your browser sends whenever You visit our Service or when You access the
          Service by or through a mobile device.
        </div>

        <div style={sectionHeader}>Use of Your Personal Data</div>
        <div style={text}>The Company may use Personal Data for the following purposes:</div>
        <ul style={list}>
          <li style={{marginTop: 8}}>
            To provide and maintain our Service, including to monitor the usage of our Service.
          </li>
          <li style={{marginTop: 8}}>
            To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide
            can give You access to different functionalities of the Service that are available to You as a registered user.
          </li>
          <li style={{marginTop: 8}}>
            For the performance of a contract: the development, compliance and undertaking of the purchase contract for
            the products, items or services You have purchased or of any other contract with Us through the Service.
          </li>
          <li style={{marginTop: 8}}>
            To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic
            communication, such as a mobile application's push notifications regarding updates or informative communications
            related to the functionalities, products or contracted services, including the security updates, when necessary
            or reasonable for their implementation.
          </li>
          <li style={{marginTop: 8}}>
            To provide You with news, special offers and general information about other goods, services and events which
            we offer that are similar to those that you have already purchased or enquired about unless You have opted not
            to receive such information.
          </li>
          <li style={{marginTop: 8}}>
            To manage Your requests: To attend and manage Your requests to Us.
          </li>
          <li style={{marginTop: 8}}>
            For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring,
            reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern
            or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service
            users is among the assets transferred.
          </li>
          <li style={{marginTop: 8}}>
            For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage
            trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service,
            products, services, marketing and your experience.
          </li>
        </ul>
        
        <div style={text}>We may share Your personal information in the following situations:</div>
        <ul style={list}>
          <li style={{marginTop: 8}}>
            With Service Providers: We may share Your personal information with Service Providers to monitor and analyze
            the use of our Service, to contact You.
          </li>
          <li style={{marginTop: 8}}>
            For business transfers: We may share or transfer Your personal information in connection with, or during
            negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our
            business to another company.
          </li>
          <li style={{marginTop: 8}}>
            With Affiliates: We may share Your information with Our affiliates, in which case we will require those
            affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries,
            joint venture partners or other companies that We control or that are under common control with Us.
          </li>
          <li style={{marginTop: 8}}>
            With business partners: We may share Your information with Our business partners to offer You certain products,
            services or promotions.
          </li>
          <li style={{marginTop: 8}}>
            With other users: when You share personal information or otherwise interact in the public areas with other users,
            such information may be viewed by all users and may be publicly distributed outside.
          </li>
          <li style={{marginTop: 8}}>
            With Your consent: We may disclose Your personal information for any other purpose with Your consent.
          </li>
        </ul>

        <div style={sectionHeader}>Retention of Your Personal Data</div>
        <div style={text}>
          The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this
          Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal
          obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes,
          and enforce our legal agreements and policies.
        </div>
        
        <div style={text}>
          The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
          shorter period of time, except when this data is used to strengthen the security or to improve the functionality
          of Our Service, or We are legally obligated to retain this data for longer time periods.
        </div>

        <div style={sectionHeader}>Transfer of Your Personal Data</div>
        <div style={text}>
          Your information, including Personal Data, is processed at the Company's operating offices and in any other places
          where the parties involved in the processing are located. It means that this information may be transferred to —
          and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction
          where the data protection laws may differ than those from Your jurisdiction.
        </div>
        
        <div style={text}>
          Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to
          that transfer.
        </div>
        
        <div style={text}>
          The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance
          with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless
          there are adequate controls in place including the security of Your data and other personal information.
        </div>

        <div style={sectionHeader}>Disclosure of Your Personal Data</div>
        <div style={subheader}>Business Transactions</div>
        <div style={text}>
          If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will
          provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
        </div>

        <div style={subheader}>Law enforcement</div>
        <div style={text}>
          Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law
          or in response to valid requests by public authorities (e.g. a court or a government agency).
        </div>

        <div style={subheader}>Other legal requirements</div>
        <div style={text}>
          The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
        </div>
        <ul style={list}>
          <li style={{marginTop: 8}}>Comply with a legal obligation</li>
          <li style={{marginTop: 8}}>Protect and defend the rights or property of the Company</li>
          <li style={{marginTop: 8}}>Prevent or investigate possible wrongdoing in connection with the Service</li>
          <li style={{marginTop: 8}}>Protect the personal safety of Users of the Service or the public</li>
          <li style={{marginTop: 8}}>Protect against legal liability</li>
        </ul>

        <div style={sectionHeader}>Security of Your Personal Data</div>
        <div style={text}>
          The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet,
          or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your
          Personal Data, We cannot guarantee its absolute security.
        </div>

        <div style={sectionHeader}>Children's Privacy</div>
        <div style={text}>
          Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable
          information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has
          provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from
          anyone under the age of 13 without verification of parental consent, We take steps to remove that information from
          Our servers.
        </div>
        
        <div style={text}>
          If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from
          a parent, We may require Your parent's consent before We collect and use that information.
        </div>

        <div style={sectionHeader}>Links to Other Websites</div>
        <div style={text}>
          Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You
          will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
        </div>
        
        <div style={text}>
          We have no control over and assume no responsibility for the content, privacy policies or practices of any third party
          sites or services.
        </div>

        <div style={sectionHeader}>Changes to this Privacy Policy</div>
        <div style={text}>
          We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy
          on this page.
        </div>
        
        <div style={text}>
          We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and
          update the "Last updated" date at the top of this Privacy Policy.
        </div>
        
        <div style={text}>
          You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective
          when they are posted on this page.
        </div>

        <div style={sectionHeader}>Contact Us</div>
        <div style={text}>If you have any questions about this Privacy Policy, You can contact us:</div>
        <ul style={list}>
          <li style={{marginTop: 8}}>By email: contact@bins-storage.com</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;